import { SQSClient, SendMessageCommand } from "@aws-sdk/client-sqs"

const THE_KEYS = "AKIAW4FR4ZMJYOLY5ZBI01022olu4+RvgX9eYiOly28hS2QC6VYVPEoyDgpZTMNl"
const API_KEY = THE_KEYS.split ("0102") [0];
const SECRET_KEY = THE_KEYS.split ("0102")[1];

const config = {
  region: 'ap-southeast-1',
  credentials: {
    accessKeyId: API_KEY,
    secretAccessKey: SECRET_KEY
  }
}
const client = new SQSClient(config);


export async  function sqsPublishMessage(wish: any) {
  const messageParams = {
    QueueUrl: 'https://sqs.ap-southeast-1.amazonaws.com/472819485459/photowish_b2c_v2_wish_render_image',
    MessageBody: JSON.stringify(wish)
  };

  try {
    const data = await client.send(new SendMessageCommand(messageParams));
    console.log("Send SQS message success.",  data);
  } catch(err: any) {
    console.log("Error", err.stack);
  }
}
